// OCHAT: los permisos de publicacion viven en ochat/config/facebookScopes.js,
// con el porque y el estado de App Review. Se suman aca porque este es el unico
// lugar donde upstream arma la lista, y el composable del alta de bandeja no
// acepta un scope por parametro.
import {
  OCHAT_PAGE_SCOPES,
  OCHAT_INSTAGRAM_SCOPES,
} from '../../ochat/config/facebookScopes';

export const FACEBOOK_PAGE_SCOPES = [
  'pages_manage_metadata',
  'business_management',
  'pages_messaging',
  'pages_show_list',
  'pages_read_engagement',
];

export const INSTAGRAM_SCOPES = [
  'instagram_basic',
  'instagram_manage_messages',
];

export const buildFacebookLoginScopes = ({
  includeInstagramScopes = false,
} = {}) => {
  const scopes = [...FACEBOOK_PAGE_SCOPES, ...OCHAT_PAGE_SCOPES];
  if (includeInstagramScopes) {
    scopes.push(...INSTAGRAM_SCOPES, ...OCHAT_INSTAGRAM_SCOPES);
  }
  return scopes.join(',');
};
